var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: "详情",
            visible: _vm.dialogShow,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            }
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.tableData.length },
              on: { click: _vm.exportdata }
            },
            [_vm._v("导出")]
          ),
          _c(
            "div",
            { staticClass: "list" },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "inline-block",
                        width: "90px",
                        "font-size": "14px"
                      }
                    },
                    [_vm._v("注册时间：")]
                  ),
                  _vm.paramsData.key == "userSsegmentationRetention"
                    ? _c("el-date-picker", {
                        attrs: {
                          clearable: false,
                          "picker-options": _vm.optionType,
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          align: "right",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期"
                        },
                        on: { change: _vm.userDateChang },
                        model: {
                          value: _vm.allDate,
                          callback: function($$v) {
                            _vm.allDate = $$v
                          },
                          expression: "allDate"
                        }
                      })
                    : _c("el-date-picker", {
                        attrs: {
                          "popper-class": "no-atTheMoment",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "请选择",
                          align: "right"
                        },
                        model: {
                          value: _vm.paramsData.register_date,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "register_date", $$v)
                          },
                          expression: "paramsData.register_date"
                        }
                      })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "margin-left": "20px"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "inline-block",
                        width: "70px",
                        "font-size": "14px"
                      }
                    },
                    [_vm._v("留存天数：")]
                  ),
                  _c("el-input", {
                    staticClass: "flex-1 no-number",
                    attrs: { type: "number", placeholder: "请输入" },
                    model: {
                      value: _vm.paramsData.retain_day,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "retain_day", _vm._n($$v))
                      },
                      expression: "paramsData.retain_day"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.searchList }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading"
                }
              ],
              staticStyle: { "margin-top": "10px" }
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.tableData, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "user_id", label: _vm.labelName }
                  })
                ],
                1
              ),
              _c("el-pagination", {
                attrs: {
                  layout: "total,sizes, prev, pager, next",
                  "current-page": _vm.currentPage,
                  total: _vm.tableCopyTableList.length,
                  "page-size": _vm.pageSize
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }